<form-control-container #container
                        [control]="controlInstance"
                        [class.readonly]="isReadonlyValue">
  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>

  <ng-container *ngIf="!isReadonlyValue">
    <div class="input-group">
      <ng-content select="[before]"></ng-content>
      <div ngbDropdown class="d-inline-block" autoClose="outside">
        <input type="text"
               [(ngModel)]="displayValue"
               (ngModelChange)="onDisplayValueChange($event)"
               [attr.name]="inputName"
               class="form-control"
               [ngClass]="{ invalid: invalid }"
               [id]="controlId"
               [disabled]="disabled"
               (focusout)="onFocusOut()"
               [autocomplete]="autocomplete ? 'on' : 'off'"
               [attr.maxlength]="18"
               [attr.placeholder]="placeholder"
               ngbDropdownToggle
               [attr.tabindex]="tabindex"
               [maskito]="maskOptions" 
        />

        <div ngbDropdownMenu [attr.aria-labelledby]="controlId">
          <div class="dropdown-item">
            <ngb-timepicker [ngModel]="timeModel"
                            [meridian]="meridian"
                            [minuteStep]="minuteStep"
                            (ngModelChange)="onTimeModelChange($event)"></ngb-timepicker>
          </div>
        </div>
      </div>

      <ng-content select="[after]"></ng-content>
    </div>
  </ng-container>

  <ng-container *ngIf="isReadonlyValue">
    <span class="readonly-value">{{ value | wafTime }}</span>
  </ng-container>
</form-control-container>
